<template>
<v-row :class="['im-result', getClass()]" no-gutters align="center">
    <v-col md="2" cols="12" class="px-2">
        <div>
            {{ item.place.name }}
        </div>
        <div>
            {{ item.section.name }}
        </div>
        <div>
            {{ item.id }}
        </div>

    </v-col>

    <v-col md="6" cols="12">
        <v-row no-gutters align="center">
            <v-col cols="12">
                <div class="pa-2">
                    {{ item.title }}
                </div>
                <div class="pa-2">
                    {{ this.getPreview() }}
                </div>
            </v-col>
        </v-row>
    </v-col>

    <v-col md="4" cols="12">
        <v-row no-gutters class="align-center">
            <v-col cols="12" md="6">
                <div>
                    <div class="pa-2">
                        {{ item.timestamp }}
                    </div>
                    <v-row no-gutters style="margin: 2px;">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    <v-icon small>forum</v-icon>
                                    <span class="px-1">{{ item.comment_sum }}</span>
                                </span>
                            </template>
                            <span>Comments</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    <v-icon small>star_border</v-icon>
                                    <span class="px-1">{{ item.rating_avg }}</span>
                                </span>
                            </template>
                            <span>Rating</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    <v-icon small>priority_high</v-icon>
                                    <span class="px-1">{{ item.order }}</span>
                                </span>
                            </template>
                            <span>Order</span>
                        </v-tooltip>
                    </v-row>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="d-flex  align-center" v-if="item.user">
                    <v-avatar size="36" class="mx-1">
                        <img v-if="item.user.avatar" :src="item.user.avatar">
                        <v-icon size="36" v-else>face</v-icon>
                    </v-avatar>
                    <div class="px-2">
                        <div class="important">
                            {{ item.user.name }}
                        </div>
                        <div class="faded">
                            {{ item.user.id }}
                        </div>
                    </div>
                </div>
                <div v-else class="important pa-1">
                    N/A
                </div>

            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
export default {
    props: {
        item: Object,
    },
    methods: {
        getClass() {
            switch (this.item.status) {
            case 'approved':
                return 'im-result-success';
            case 'pending':
                return 'im-result-warning';
            case 'rejected':
                return 'im-result-danger';
            default:
                return '';
            }
        },

        getPreview() {
            // we eliminate images
            let regex = /<img.+?>/gi;
            let text = this.item.body.replace(regex, '');
            // we eliminate other html tags
            regex = /<.+?>/gi;
            text = text.replace(regex, ' ');

            let text_size = 250;
            if(text.length < text_size) {
                return text;
            }
            return text.substring(0, text_size)
                .concat("...");
        },

        emitClick() {
            this.$emit('click');
        },
    },

}
</script>

<style>
.item:hover {
    cursor: pointer;
    background-color: #ECEFF1 !important;
}
</style>
